<template>
  <!--  -->
  <div id="nav" class="hidden md:flex flex-col w-64 h-screen absolute md:relative overflow-auto" :class="{ 'hide-menu': ShowSidebar(), 'vertical-navigation-mode-over': resize(), }" style="z-index: 1000;">
    <!--  -->
    <div class="flex items-center gap-2 bg-primary-600 justify-center sticky top-0 p-2">
      <!--  -->
      <router-link class="flex items-center no-active dashbord" to="/">
        <!--  -->
        <img alt="..." class=" h-8 rounded-lg align-middle border-none" :src="image" />
        <!--  -->
      </router-link>
      <!--  -->

      <!--  -->
      <button class="flex items-center justify-center bg-white rounded-full p-1" v-if="resize()" @click="actionSidebar">
        <!--  -->
        <i style="font-size: 20px" class="material-icons text-orange-600">close</i>
        <!--  -->
      </button>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <div class="h-full p-2 pt-4 text-md font-normal bg-primary-600 text-white" :class="$colors.sideBar">
      <!--  -->
      <menu-link v-if="user.type != 'SubUser' && user.type != 'TeleConsultant' && user.type != 'CallcenterManager'" to="/" :text="$t('dashboard')" class="link" icon="dashboard" />
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('warehouses') && (getAccess('warehouses', 'create') || getAccess('warehouses', 'watch'))" to="/warehouses" :text="$t('warehouses')" class="link" icon="business" />
      <!--  -->

      <!--  -->
      <div v-if="['warehouses', 'newWarehouse'].indexOf($route.name) > -1 && getAccess('warehouses', 'create')">
        <!--  -->
        <menu-link to="/warehouses/new" :text="$t('new_warehouse')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('products') && (getAccess('products', 'create') || user.type == 'StockManager' || getAccess('products', 'watch'))" to="/products" :text="$t('products')" class="link" icon="local_mall" />
      <!--  -->
      
      <!--  -->
      <div v-if="['products', 'newProduct'].indexOf($route.name) > -1 && getAccess('products', 'create')">
        <!--  -->
        <menu-link to="/products/new" :text="$t('new_product')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getAccess('analytics', 'create') && getAccess('analytics', 'watch') " to="/callcenter" :text="$t('analytics')" class="link" icon="trending_up" />
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('orders') && (getAccess('orders', 'create') || getAccess('orders', 'watch'))" to="/orders" :text="$t('orders')" class="link" icon="local_grocery_store" />
      <!--  -->

      <!--  -->
      <div v-if="['orders', 'newOrder'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/orders/new" v-if="getAccess('orders', 'create')" :text="$t('new_order')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="user.type == 'TeleConsultant'" to="/orders/confirmation" :text="$t('confirmation')" icon="add" />
      <!--  -->

      <!--  -->
      <div v-if="['orders', 'importOrders'].indexOf($route.name) > -1 && user.type !== 'TeleConsultant'">
        <!--  -->
        <menu-link to="/orders/import" v-if="getAccess('orders', 'create')" :text="$t('import_orders')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('chat') && (getAccess('chat', 'create') || getAccess('chat', 'watch'))" to="/messages" :text="$t('Messages')" class="link" icon="chat" />
      <!--  -->

      <!--  -->
      <menu-link v-if="(getPermission('expeditions') && !dataWhrahouseSetting) || (getAccess('expeditions', 'watch') && !dataWhrahouseSetting) || (dataWhrahouseSetting && dataWhrahouseSetting.fulfillement)" to="/expeditions" :text="$t('expeditions')" class="link" icon="local_airport" />
      <!--  -->

      <!--  -->
      <div v-if="['expeditions', 'newExpedition'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/expeditions/new" :text="$t('new_expedition')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div v-if="['expeditions', 'newExpedition', 'internalexpedition'].indexOf( $route.name, ) > -1 && getAccess('internalexpeditions', 'create')">
        <!--  -->
        <menu-link to="/internalexpeditions" text="Internal expeditions" icon="airplanemode_inactive" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('status') && (getAccess('status', 'create') || getAccess('status', 'watch'))" to="/status" :text="$t('status')" class="link" icon="sync" />
      <!--  --> 

      <!--  -->
      <menu-link v-if="getPermission('users') && (getAccess('users', 'create') || getAccess('users', 'watch'))" to="/users" :text="$t('users')" class="link" icon="account_circle" />
      <!--  -->

      <!--  -->
      <div v-if="['users', 'newUser'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/users/new" text="New user " icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div v-if="['users', 'historyUser'].indexOf($route.name) > -1 && getPermission('userHistories')">
        <!--  -->
        <menu-link to="/users/history" text="History" icon="history" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('groups') && (getAccess('groups', 'create') || getAccess('groups', 'watch'))" to="/groups" :text="$t('groups')" class="link" icon="group" />
      <!--  -->

      <!--  -->
      <div v-if="['groups', 'newGroup'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/groups/new" text="New group" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->
      
      <!--  -->
      <menu-link v-if="getPermission('roles') && (getAccess('roles', 'create') || getAccess('roles', 'watch')) " to="/roles" :text="$t('roles')" class="link" icon="lock" />
      <!--  -->

      <!--  -->
      <div v-if="['roles', 'newRole'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/roles/new" :text="$t('new_role')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('teams') || getAccess('teams', 'watch')" to="/teams" :text="$t('teams')" class="link" icon="group" />
      <!--  -->

      <!--  -->
      <div v-if="['teams', 'newTeam'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/teams/new" :text="$t('new_team')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->
      
      <!--  -->
      <menu-link v-if="getPermission('subscribers') || getAccess('subscribers', 'watch')" to="/subscribers" :text="$t('subscribers')" class="link" icon="supervisor_account" />
      <!--  -->

      <!--  -->
      <div v-if="['subscribers', 'newSubscribers'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/subscribers/new" :text="$t('new_subscriber')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if=" getPermission('shippings') && (getAccess('shippings', 'create') || getAccess('shippings', 'watch') || getAccess('zones', 'watch') || getAccess('zones', 'create')) " to="#" :text="$t('shipping_order')" class="link" icon="local_shipping" :isActive="isActive" @myFilter="myFilter" />
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('zones') && (getAccess('zones', 'create') || getAccess('zones', 'watch'))" to="/zones" :text="$t('zones')" class="link" icon="map" children="true" />
        <!--  -->
        <div v-if="['zones', 'newZones'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link to="/zones/new" :text="$t('new_zone')" icon="add" class="child" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('shippings') && (getAccess('shippings', 'create') || getAccess('shippings', 'watch'))" to="/shippings" :text="$t('shippings')" class="link" icon="map" children="true" />
        <!--  -->
        <menu-link v-if="getPermission('payments') || getAccess('payments', 'watch')" to="/payments" :text="$t('payments')" class="link" icon="payment" />
        <!--  -->
        <div v-if="['payments', 'newPayments'].indexOf($route.name) > -1 && (getAccess('payments', 'create') || getAccess('payments', 'update'))">
        <!--  -->
        <menu-link to="/payments/new" :text="$t('new_payment')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <menu-link v-if="getPermission('cashflow')" to="/cashflow" :text="$t('cashflow')" class="link" icon="monetization_on" />
      <!--  -->
      
      <!--  -->
      <div v-if="['cashflow', 'newCashflow'].indexOf($route.name) > -1">
        <!--  -->
        <menu-link v-if="getPermission('cashflow') && getAccess('cashflow', 'create')" to="/cashflow/new" :text="$t('new_cashflow')" icon="add" submenu="true" />
        <!--  -->
      </div>
      <!--  -->
      
      <!--  -->
      <menu-link v-if="getPermission('settings') && getAccess('settings', 'update')" to="/settings" :text="$t('settings')" class="link" icon="settings" />
      <!--  -->
      
      <!--  -->
      <menu-link to="/orders/api" v-if="user.type == 'CEO' || user.type == 'Seller'" :text="$t('API')" icon="device_hub" class="link" />
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      login: false,
      token: null,
      isActive: false,
      status: false,
      hideMenu: false,
      image: 'https://storeno.b-cdn.net/vex/logo.png',
      dataWhrahouseSetting: null,
    };
  },
  props: ['idWharhouse', 'user'],
  watch: {
    idWharhouse: async function(oldVal) {
      this.idWharhouse = oldVal;

      if (this.user.type == 'Seller' && this.user.settings.length > 0)
        this.dataWhrahouseSetting = this.getElementInArray(
          this.user.settings,
          this.idWharhouse._id,
        );
    },
  },
  async mounted() {
    this.token = this.$jwtService.getToken();

    if (this.user) {
      this.getAccess('users', 'read');

      if (this.user.type == 'Seller' && this.user.settings.length > 0)
        this.dataWhrahouseSetting = this.getElementInArray(
          this.user.settings,
          this.idWharhouse._id,
        );
    }
  },
  methods: {
    ShowSidebar() {
      return this.$store.getters.ShowSidebar;
    },
    getElementInArray(data, value) {
      var result = data.filter(function(o) {
        let whar = o.warehouse;

        if (o.warehouse._id) whar = o.warehouse._id;

        return whar == value && value.toString();
      });

      return result ? result[0] : null;
    },
    actionSidebar() {
      this.$store.dispatch('actionSidebar');
    },
    resize() {
      return this.$store.getters.resize;
    },
    myFilter: function() {
      this.isActive = !this.isActive;
    },
    async getStatusUser() {
      if (this.user.status == 'active') {
        this.status = true;
      } else {
        this.status = false;
      }
    },
    async getUser() {
      const res = await this.$server.me('users');

      if (res.content) {
        this.user = res.content;
      } else {
        this.user = [];
      }
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = '/';
    },
    getAccess(modelToCheck, accessToCheck) {
      const permissions = this.user.role.permissions;

      for (let i in permissions) {
        let model = permissions[i]['model'];

        let access = permissions[i]['access'];

        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    },
    getPermission(name) {
      if (this.user) {
        const permissions = this.user.role.permissions;

        for (let i in permissions) {
          let model = permissions[i]['model'];

          let access = permissions[i]['access'];

          if (model == name) {
            if (
              access.create ||
              access.read ||
              access.update ||
              access.delete
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  padding-left: 5px;
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 40px;
  background:  #fd4100;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #1c78ce;
}
</style>
